import { useQueryClient, type DefaultError } from '@tanstack/vue-query'
import { extractErrorMsgFromFailedRequest } from '~/utils/request-helpers'
import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack'
import type { WishlistedVariantIds } from '~/types/api/bff/web/wishlist/wishlist.types'

export const useUpdateWishlistVariantMutation = (
  productName: string,
  userId: MaybeRefOrGetter<string | undefined>,
  options?: NitroFetchOptions<NitroFetchRequest>
) => {
  const { $wishlistRepository } = useNuxtApp()
  const client = useQueryClient()
  const { notify } = useNotification()
  const { t } = useI18n()

  return {
    mutationKey: getAddWishlistMutationKey(userId),
    mutationFn: (variantId: string) =>
      $wishlistRepository.update(variantId, {}, unref(options)),
    onSuccess: (data: WishlistedVariantIds) => {
      client.setQueryData(getWishlistQueryKey(userId), data)

      notify({
        type: 'success',
        text: t('wishlist.added', { productName }),
      })

      updateLocalStorageWishlistedIds(data)
    },
    onError: (error: DefaultError) => {
      notify({
        type: 'error',
        text: extractErrorMsgFromFailedRequest(error),
      })
    },
  }
}
